<template>
  <div class="fun-factor-area" v-show="showFacts" style="padding: 60px 0 67px">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title-wrapper white">
            <div class="section-title">
              <h3 style="margin-bottom: 24px">{{ impFact }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="Facts in Facts"
          :key="Facts.postId"
          class="col-lg-3 col-md-3 col-12"
        >
          <div class="single-fun-factor">
            <h4>{{ Facts.postTitle }}</h4>
            <h2>
              {{ Facts.postSubTitle }}
              <!-- <span class="counter">{{ Facts.postSubTitle }}</span> -->
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ArJson from "../../../public/i18n/Ar.json";
import EnJson from "../../../public/i18n/En.json";

export default {
  data() {
    return {
      showFacts: true,
      Facts: [],
      impFact: "",
      direction: "right",
      lang: "",
      ArTranslat: ArJson,
      EnTranslat: EnJson,
      translate: "",
    };
  },
  mounted() {
    var self_ = this;
    if (localStorage.getItem("lang") == null) {
      self_.getApis();
      axios({
        method: "get",
        url: "https://api2.yg-u.net:444/languages/getLangIsMain",
      }).then(function (response) {
        localStorage.setItem("lang", response.data[0]["LangId"]);
      });
    } else self_.getApis();
  },
  methods: {
    getApis() {
      window.scroll(0, 0);
      var self = this;

      if (localStorage.getItem("lang") == "Ar") {
        self.translate = self.ArTranslat;
        self.direction = "right";
      } else {
        self.translate = self.EnTranslat;
        self.direction = "left";
        let link1 = document.createElement("link");
        link1.setAttribute("rel", "stylesheet");
        link1.id = "langfilewebsites";
        link1.setAttribute("href", "./style-ltr.css");
        document.head.appendChild(link1);
      }
      self.impFact = self.translate[0]["Home"]["impFact"];

      var bodyFormData = new FormData();
      bodyFormData.append("check", "getPost");
      bodyFormData.append("PostId", "");
      bodyFormData.append("Lang", localStorage.getItem("lang"));
      bodyFormData.append("FbrnId", "");
      bodyFormData.append("Type", "Univ.Home.Sec.Facts");
      bodyFormData.append("ParentId", "NTROOT0");
      bodyFormData.append("PostName", "");
      bodyFormData.append("Pno", "8");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormData,
      })
        .then(function (response) {
          self.Facts = response.data;
          var arr = response.data;
          if (arr.length != 0) {
            self.showFacts = true;
          } else {
            self.showFacts = false;
          }

          setTimeout(() => {
            self.show = false;
          }, 100);
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
    },
  },
};
</script>
